import { Component, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

/**
 * Without a boundary, React unmounts the whole root on any render error and
 * leaves a blank page that only F5 brings back. This one wraps the entire app,
 * so its fallback cannot rely on the router or any provider.
 */
export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
        <div className="max-w-sm space-y-6 text-center">
          <img
            src="/assets/images/logo.svg"
            alt="GetMatch Logo"
            className="mx-auto h-16 w-auto"
          />
          <div className="space-y-2">
            <h1 className="font-gilroy text-xl font-bold text-primary">
              Algo salió mal
            </h1>
            <p className="font-opensans text-sm text-gray-600">
              Ocurrió un error inesperado. Recargá la página para seguir.
            </p>
          </div>
          <Button onClick={() => window.location.reload()}>
            Recargar página
          </Button>
        </div>
      </div>
    );
  }
}
